import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=3f0bc09c&"
import script from "./Tariffs.vue?vue&type=script&lang=js&"
export * from "./Tariffs.vue?vue&type=script&lang=js&"
import style0 from "./Tariffs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports